import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'soft-wiegung',
  templateUrl: './wiegung.component.html',
  styleUrls: ['./wiegung.component.css'],
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class WiegungComponent {}
